import {FC} from 'react';
import {UserInvoices} from 'src/components/invoices/UserInvoices';

/**
 * The invoices a business issues to its people.
 *
 * One screen for everyone now. A platform administrator used to get RevenueInvoices here instead -
 * AMP IT's own invoices *to* the businesses - which answers a different question and, since
 * RevenueInvoiceService skips business 1 when it generates them, was empty for the business they
 * work in by default. The revenue screen is untouched and still in the codebase; it has no entry
 * point until it gets one of its own.
 */
export const Invoices: FC = () => {
    return <UserInvoices/>;
};
